import { apiClient } from '@/services/ApiClient.js'

export default {
  getCoupons(query) {
    return apiClient
      .get('coupons', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getCoupon(id) {
    return apiClient
      .get('coupons/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createCoupon(coupon) {
    return apiClient
      .post('coupons', coupon)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteCoupon(id) {
    return apiClient
      .delete('coupons/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createDiscountRange({ coupon, discountRange }) {
    return apiClient
      .post('coupons/' + coupon.id + '/coupon-discount-ranges', discountRange)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteDiscountRange(couponId, discountRangeId) {
    return apiClient
      .delete('coupons/' + couponId + '/coupon-discount-ranges/' + discountRangeId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getRequirements(requireable_type, name = null) {
    return apiClient.post('coupons/requirements', { requireable_type: requireable_type, name: name }).then(response => {
      return response
    })
  },
  createRequirement({ coupon, requirement }) {
    return apiClient
      .post('coupons/' + coupon.id + '/coupon-requirements', requirement)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteRequirement(couponId, requirementId) {
    return apiClient
      .delete('coupons/' + couponId + '/coupon-requirements/' + requirementId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  importTCKN(form) {
    let formData = new FormData()
    formData.append('file', form.file)

    return apiClient
      .postForm('/coupons/nins', formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
